import styled from "styled-components";
import { Select } from "../Select";
export const CountrySelector = styled(Select)`
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  cursor: default;
  position: inherit;
  width: 104px;
`;